import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var TextParagraph = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 12.25C12.25 9.9 14.15 8 16.5 8h4.75a.75.75 0 0 1 0 1.5H21v11.75a.75.75 0 0 1-1.5 0V9.5h-1v11.75a.75.75 0 0 1-1.5 0V16.5h-.5a4.25 4.25 0 0 1-4.25-4.25zM3 5a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2H3zM11.76 10H3a1 1 0 1 0 0 2h8.26c.03-.71.2-1.39.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.03 15H3a1 1 0 1 0 0 2h11.26a5.27 5.27 0 0 1-2.23-2z"
  }));
});
TextParagraph.displayName = 'TextParagraph';
export var TextParagraphDimensions = {
  height: 24,
  width: 24
};